import axios, { AxiosRequestConfig } from 'axios';
import { getDomainName } from './commonFunctions';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();

const isCheckCookie = () => {
  const  domain = getDomainName();
  const isIomarket = domain?.toLowerCase().replace(/-/g, '').includes('iomarket') ?? false;
  const cookieName = isIomarket ? 'expireCookie' : 'loginCookie';
  const isValidCookie = cookies.get(cookieName);

  return isValidCookie
};

const axiosServices = axios.create({ baseURL: 'https://pdevl.api.' + getDomainName() +'/api/v1/' });
// const axiosServices = axios.create({ baseURL: import.meta.env.VITE_APP_API_URL || 'http://localhost:3010/' });
export const getAccountApiService = () => {
   return axios.create({baseURL: 'https://fjy29.api.' + getDomainName() +'/api/v1/'});
  // return axios.create({baseURL: 'http://testrahul.' + getDomainName() +':4000/api/v1/'});
};
export const accountApiServices = getAccountApiService();

export const getInvoiceApiService = () => {
  return axios.create({ baseURL: import.meta.env.VITE_APP_INVOICE_URL || 'https://dfh56.api.io-netgate.net/api/v1' });
};
export const invoiceApiServices = getInvoiceApiService();

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.request.use(
  async (config) => {
        // Retrieve login information from cookies
      const login = isCheckCookie(); 
    
      // If the user is not logged in, exit the interceptor
      if (!login) return config;
  
      // Set default for withCredentials if not already specified
      if (typeof config.withCredentials === 'undefined') {
        config.withCredentials = true;
      }
      // Set 'Accept-Language' header based on the presence of 'language' in headers
      config.headers['Accept-Language'] = config.headers['Accept-Language'] || 'en';    
      return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401 && !window.location.href.includes('/login')) {
      window.location.pathname = '/';
    }
    return Promise.reject((error.response && error.response.data) || 'Wrong Services');
  }
);

export default axiosServices;

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  try {
    const [url, config] = Array.isArray(args) ? args : [args];
    const res = await axiosServices.get(url, { ...config });
    return res.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

export const fetcherPost = async ([url, formData]: [string, FormData | null]) => {
  try {
    const res = await axiosServices.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true
    });
    return res.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

export const fetcherPatch = async ([url, formData]: [string, FormData | null]) => {
  try {
    const res = await axiosServices.patch(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true
    });
    return res.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

export const fetcherDelete = async (args: string | [string, AxiosRequestConfig]) => {
  try {
    const [url, config] = Array.isArray(args) ? args : [args];
    const res = await axiosServices.delete(url,{ ...config });
    return res.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

export const fetchAccountApi = async (args: string | [string, FormData | null]) => {
  try {
    const [url, config] = Array.isArray(args) ? args : [args];
    const res = await accountApiServices.post(url, config); 
    return res.data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};
